import { useEffect, useRef, useState } from "react";
import styles from "./MobileComponents.module.css";
import Slider from "@mui/material/Slider";
import Muted from "../../../../components/icons/Muted";
import Volume from "../../../../components/icons/Volume";

interface IProps {
  maxValue: any;
  time: any;
  player: any,
  setTime: (value: number) => void;
  isMobile?: boolean;
  horizontal?: boolean;
  muted?: boolean;
  onToggleMuted?: () => void;
}

const MobileProgressController = ({
                                    maxValue,
                                    time,
                                    player,
                                    setTime,
                                    isMobile,
                                    horizontal,
                                    muted,
                                    onToggleMuted,
                                  }: IProps) => {
  const [progressActive, setProgressActive] = useState(false);
  const hoverTimerRef = useRef<number | null>(null);

  const formatTime = (value: number) => {
    if (!Number.isFinite(value) || value < 0) return "00:00";
    const totalSeconds = Math.floor(value);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const clearHoverTimer = () => {
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
      hoverTimerRef.current = null;
    }
  };

  const activateProgress = () => {
    if (!isMobile) return;
    clearHoverTimer();
    setProgressActive(true);
    hoverTimerRef.current = window.setTimeout(() => {
      setProgressActive(false);
    }, 3000);
  };

  useEffect(() => {
    return () => clearHoverTimer();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowRight') {
        setTime(time + 15);
        if (player) {
          player.seekTo(time + 15, 'seconds');
        }
      } else if (event.key === 'ArrowLeft') {
        setTime(time - 15);
        if (player) {
          player.seekTo(time - 15, 'seconds');
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [time, setTime, player]);

  return (
    <div
      className={`${styles.progressControllerWrapper} ${isMobile ? styles.progressControllerWrapperMobile : ''} ${
        isMobile && progressActive ? styles.progressControllerWrapperMobileActive : ''
      } ${horizontal ? styles.progressControllerWrapperLandscape : ''}`}
    >
      <Slider
        className={`${isMobile ? "progress-controller-mobile" : "progress-controller"}${
          isMobile && progressActive ? " progress-controller-mobile-active" : ""
        }${horizontal ? " progress-controller-mobile-landscape" : ""}`}
        min={0}
        max={maxValue as number}
        defaultValue={0}
        value={time}
        onChange={(_, value) => {
          activateProgress();

          if (player) {// @ts-ignore
            player.seekTo(value, 'seconds');
          }
          setTime(value as number);
        }}
        onClick={activateProgress}
      />
      {horizontal && <span className={styles.progressTimer}>{formatTime(time)}</span>}
      {onToggleMuted && (
        <button
          type="button"
          className={styles.progressMuteButton}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onToggleMuted();
          }}
          aria-label={muted ? "Unmute" : "Mute"}
        >
          <span key={muted ? "muted" : "unmuted"} className={styles.progressMuteIcon}>
            {muted ? <Muted /> : <Volume />}
          </span>
        </button>
      )}
    </div>
  )
};

export default MobileProgressController;
